import { useMemo } from 'react';

const levenshtein = (a, b) => {
    a = a || '';
    b = b || '';
    const matrix = Array.from({ length: b.length + 1 }, () =>
        Array(a.length + 1).fill(0)
    );

    for (let i = 0; i <= b.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            matrix[i][j] = b[i - 1] === a[j - 1]
                ? matrix[i - 1][j - 1]
                : Math.min(
                    matrix[i - 1][j - 1] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j] + 1
                );
        }
    }
    return matrix[b.length][a.length];
};

const useTranscriptCorrector = (termCorrections, threshold = 2) => {
    const correctTranscript = useMemo(() => {
        return (text) => {
            let correctedText = text;
            let lowerText = text.toLowerCase();

            for (const [wrong, correct] of Object.entries(termCorrections)) {
                const wrongLower = wrong.toLowerCase();
                const regex = new RegExp(`\\b${wrongLower}\\b`, 'gi');

                if (regex.test(lowerText)) {
                    correctedText = correctedText.replace(new RegExp(wrong, 'gi'), correct);
                } else {
                    // Fuzzy Matching
                    const words = correctedText.split(/\s+/);
                    const lowerWords = lowerText.split(/\s+/);

                    correctedText = words.map((word, index) => {
                        const wordLower = lowerWords[index];
                        const distance = levenshtein(wordLower, wrongLower);

                        if (wordLower !== correct.toLowerCase() && distance <= threshold) {
                            return correct;
                        }
                        return word;
                    }).join(' ');
                }
            }
            return correctedText;
        };
    }, [termCorrections, threshold]);

    return { correctTranscript };
};

export default useTranscriptCorrector;
